var cash = "https://shopfront-cdn.tekoapis.com/static/0e924ede5a93187b.svg";

export { cash as default };
